export const groupSurplusOthers = <TItem, TSplit>({
  surplus,
  mapToSplit,
  buildOthersSplit,
  maxOthersInTooltip,
}: {
  surplus: TItem[]
  mapToSplit: (item: TItem) => TSplit
  buildOthersSplit: (surplus: TItem[], surplusToGroup: TItem[]) => TSplit
  maxOthersInTooltip: number
}): TSplit[] => {
  if (surplus.length === 0) return []
  if (surplus.length === 1) return surplus.map(mapToSplit)
  if (surplus.length <= maxOthersInTooltip) {
    return [buildOthersSplit(surplus, [])]
  }
  const visibleInTooltip = Math.max(maxOthersInTooltip - 1, 0)
  const surplusToDisplay = surplus.slice(0, visibleInTooltip)
  const surplusToGroup = surplus.slice(visibleInTooltip)
  return [buildOthersSplit(surplusToDisplay, surplusToGroup)]
}
